<template>
  <b-form class="mt-3" @submit="onSubmitForm">
    <b-row>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <!-- <b-col cols="12" md="6">
        <InputFilter :filter="search[1]" />
      </b-col> -->
      <b-col cols="12" md="6">
        <InputFilter :filter="search[2]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[3]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[4]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[5]" />
      </b-col>

      <!-- TEST SELECT -->
    </b-row>
    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        type="submit"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import index from "vue-prism-component";
import vSelect from "vue-select";
import InputFilter from "../../../filters/components/InputFilter.vue";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    vSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const searchList = [
      {
        id: "name",
        label: "ชื่อผู้ใช้งาน",
        value: "",
        class: "",
        style: "",
        placeholder: "ชื่อผู้ใช้งาน",
        type: "text",
        options: [],
      },
      {
        id: "menu",
        label: "ชื่อเมนู",
        value: "",
        class: "",
        style: "",
        placeholder: "ชื่อเมนู",
        type: "text",
        options: [],
      },
      {
        id: "ip",
        label: "Ip / Device",
        value: "",
        class: "",
        style: "",
        placeholder: "Ip / Device",
        type: "text",
        options: [],
      },
      {
        id: "action",
        label: "Action",
        value: "",
        class: "",
        style: "",
        placeholder: "Action",
        type: "text",
        options: [],
      },
      {
        id: "startdateSearch",
        label: "ช่วงเวลาดำเนินการ",
        value: "",
        class: "",
        style: "",
        placeholder: "จากวันที่",
        type: "date",
        options: [],
      },
      {
        id: "enddateSearch",
        label: "ถึง",
        value: "",
        class: "",
        style: "",
        placeholder: "ถึงวันที่",
        type: "date",
        options: [],
      },
    ];
    return {
      search: searchList,
      props,
    };
  },
  methods: {
    onSubmitForm(e) {
      e.preventDefault();
      this.onSearchBtnClicked();
    },
    onResetBtnClicked() {
      this.search.forEach((item) => {
        item.value.forup = null;
      });
    },
    onSearchBtnClicked() {
      const params = {
        companyName: this.search[0].value,
        menuName: this.search[1].value,
        ipDevice: this.search[2].value,
        action: this.search[3].value,
        loginStartDate: this.search[4].value,
        loginEndDate: this.search[5].value,
      };
      this.$emit("handleSubmit", params);
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
